import dynamic from 'next/dynamic'

const Column = dynamic<any>(
  () => import('@ant-design/plots').then(({ Column }) => Column),
  { ssr: false }
)
export { Column }